exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i[data-v-40bb8bbb]{color:#fc0!important}", ""]);

// exports
